export const contactUsInitialValues = {
  fullName: "",
  emailId: "",
  country: "",
  phoneNo: "",
  message: "",
};
